import { fetchLoyaltyEstimate } from 'actions/loyalty/LoyaltyApi';
import {
    LOYALTY_ESTIMATE_FETCH_START,
    LOYALTY_ESTIMATE_FETCH_SUCCESS,
    LoyaltyAction
} from 'actions/loyalty/LoyaltyActionsTypes';
import { ThunkAction } from 'redux-thunk';
import { RootState } from 'store';
import { RootAction } from 'types/Actions';
import { LoyaltyEstimate, LoyaltyEstimateItem } from 'types/Loyalty';

const LOYALTY_SOURCE_ONLINE_BOOKING = 'online_booking';

export const fetchLoyaltyEstimateThunk = (
    marketplaceId: number,
    items: Array<LoyaltyEstimateItem>,
    customerId?: number
): ThunkAction<Promise<LoyaltyEstimate>, RootState, null, RootAction> => {
    return async dispatch => {
        dispatch(fetchStart());

        const estimate = await fetchLoyaltyEstimate({
            marketplace_id: marketplaceId,
            customer_id: customerId,
            source: LOYALTY_SOURCE_ONLINE_BOOKING,
            items
        });

        dispatch(fetchSuccess(estimate));

        return estimate;
    };
};

const fetchStart = (): LoyaltyAction => {
    return {
        type: LOYALTY_ESTIMATE_FETCH_START
    };
};

const fetchSuccess = (estimate: LoyaltyEstimate): LoyaltyAction => {
    return {
        type: LOYALTY_ESTIMATE_FETCH_SUCCESS,
        payload: {
            estimate
        }
    };
};
